import { Injectable, Inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { UnidadService } from 'src/app/modules/enjoy-cl/unidad/services/unidad.service';
import { Unidad } from 'src/app/models/unidad';
import { DataService } from '../services/data.service';
import { Util } from '../utils/functions';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ServicioGuard implements Resolve<any> {

  unidadSelected: Unidad;
  habitacion: any;
  servicioSpa: any;
  gastronomia: any;
  negocios: any;

  constructor(
    private unidadService: UnidadService,
    private dataService: DataService,
    private router: Router,
    @Inject(PLATFORM_ID) public platformId: Object

  ) { }

  async resolve(next: ActivatedRouteSnapshot): Promise<any> {
      if (isPlatformBrowser(this.platformId)) {

        const path = next.routeConfig.path; // Path recuperada ActivatedRouteSnapshot
        this.dataService.currentUnidadSelected.subscribe(unidadSelected => this.unidadSelected = unidadSelected)

        /* OK HOTEL */
        if (path === ':idHotel') {
          this.unidadService.idHabitacion$.subscribe(habitacion => this.habitacion = habitacion);
          if (!this.habitacion[0] && !this.habitacion[1]) {
            const contenidoHotel = await this.unidadService.contenidoHotelUnidad(this.unidadSelected.idUnidad, 1);
            if (contenidoHotel['codigo'] === 1) {
              const servicio = next.params.idHotel; // Path recuperada ActivatedRouteSnapshot
              const room = await contenidoHotel['data']['habitaciones'].filter(habitacion => {
                return servicio === Util.eliminarDiacriticos(habitacion.tituloHabitacion.toLowerCase().replace(/[' ']+/g, '-'))
              })
              this.unidadService.setDataHabitacion([room[0].idHabitacion, room[0].tituloHabitacion])
              return true;
            } else {
              this.router.navigate(['home']);
              return true;
            }
          } else {
            return true;
          }
        }

        /* OK SPA */
        if (path === ':idSpa') {
          this.dataService.$idServicioSpa.subscribe(servicio => this.servicioSpa = servicio);
          if (this.servicioSpa === 0) {
            const contenidoSpa = await this.unidadService.contenidoSpaUnidad(this.unidadSelected.idUnidad, 1);
            if (contenidoSpa['codigo'] === 1) {
              const servicio = next.params.idSpa; // Path recuperada ActivatedRouteSnapshot
              const service = await contenidoSpa['data'].servicios.filter(serv => {
                return servicio === Util.eliminarDiacriticos(serv.tipoServicio.toLowerCase().replace(/[' ']+/g, '-'))
              })
              this.dataService.setServicioSpa(service[0].idTipoServicio);
              return true;
            } else {
              this.router.navigate(['home']);
              return true;
            }
          } else {
            return true;
          }
        }

        /* OK GASTRONOMIA */
        if (path === ':idGastronomia') {
          this.unidadService.idGastronomia$.subscribe(gastronomia => this.gastronomia = gastronomia);
          if (this.gastronomia.length === 0) {
            const contenidoGastronomia = await this.unidadService.contenidoGastronomiaUnidad(this.unidadSelected.idUnidad, 1);
            if (contenidoGastronomia['codigo'] === 1) {
              const servicio = Util.eliminarDiacriticos(next.params.idGastronomia); // Path recuperada ActivatedRouteSnapshot
              const service = await contenidoGastronomia['data'].restaurants.filter(restaurant => {
                return servicio === Util.eliminarDiacriticos(restaurant.tituloRestaurant.toLowerCase().replace(/[' ']+/g, '-'))
              })
              this.unidadService.setDataGastronomia(service[0]);
              return true;
            } else {
              this.router.navigate(['home']);
              return true;
            }
          } else {
            return true;
          }
        }

        /* OK CENTRO DE NEGOCIOS */
        if (path === ':idNegocio') {
          this.unidadService.idSalon$.subscribe(negocios => this.negocios = negocios);
          if (this.negocios.length === 0) {
            const contenidoNegocios = await this.unidadService.contenidoCentroNegocios(this.unidadSelected.idUnidad, 1);

            if (contenidoNegocios['codigo'] === 1) {
              const servicio = next.params.idNegocio; // Path recuperada ActivatedRouteSnapshot
              const service = await contenidoNegocios['data'].salones.filter(salon => {
                return servicio === Util.eliminarDiacriticos(salon.tituloSalon.toLowerCase().replace(/[' ']+/g, '-'))
              })
              this.unidadService.setDataSalon([service[0].idSalon, contenidoNegocios['data'].salones]);
              return true;
            } else {
              this.router.navigate(['home']);
              return true;
            }
          } else {
            return true;
          }
        }

        /* OK EVENTOS */
        if (path === ':idEvento') {
          this.unidadService.idSalon$.subscribe(negocios => this.negocios = negocios);
          if (this.negocios.length === 0) {
            const contenidoEventos = await this.unidadService.contenidoEventosUnidad(this.unidadSelected.idUnidad, 1);
            if (contenidoEventos['codigo'] === 1) {
              const servicio = next.params.idEvento; // Path recuperada ActivatedRouteSnapshot
              const service = await contenidoEventos['data'].salones.filter(salon => {
                return servicio === Util.eliminarDiacriticos(salon.tituloSalon.toLowerCase().replace(/[' ']+/g, '-'))
              })
              this.unidadService.setDataSalon([service[0].idSalon, contenidoEventos['data'].salones]);
              return true;
            } else {
              this.router.navigate(['home']);
              return true;
            }
          } else {
            return true;
          }
        }

      }


  }
}
